import './geoRegistrationTool.less';
import {Viewer} from 'neuroglancer/viewer';
import {RefCounted} from "neuroglancer/util/disposable";
import {SliceViewPanel} from "neuroglancer/sliceview/panel";
import {mat4, vec2} from "gl-matrix";
import debounce from "lodash/debounce";
import {SliceViewProjectionParameters} from "neuroglancer/sliceview/base";
import {makeElement} from "neuroglancer/ui/layer_gene_table_tab";
import {WatchableValue} from "neuroglancer/trackable_value";
import { NavigationState } from '../navigation_state';
import { animationFrameDebounce } from '../util/animation_frame_debounce';

const geoLineWidth = 1.2;

function projectToScreenCoord(point: vec2, projectionParameters: SliceViewProjectionParameters): [number, number] {
  let resultPos1 = vec2.transformMat4(vec2.create(), point, projectionParameters.viewProjectionMat);
  return [(1 + resultPos1[0]) * projectionParameters.width / 2, projectionParameters.height - (1 + resultPos1[1]) * projectionParameters.height / 2];

}

export class tissueGefOutline extends RefCounted {
  registrationCanvas = document.createElement('canvas');//绘制测量的画布
  ctx: CanvasRenderingContext2D | null = this.registrationCanvas.getContext('2d');
  matrixFlip: mat4
  scaleDom = makeElement('div',['neuroglancer-scale-dom']);
  displacement_num_driveDiv = makeElement('div', [], { 'style': 'margin:1rem 0;justify-content: center;height: 11rem' });  //  移动方向按钮
  displacement_num_div = makeElement('div', ['neuroglancer-transform-displace-num']);  //  移动步进

  transformUI = makeElement('div', ['transform-v3-ui']);
  rotateVal = new WatchableValue(0);
  geoData_:any = undefined;
  is_fill: string = 'Outlined';
  constructor(public viewer: Viewer, public navigationState: NavigationState) {
    super();
    this.initDom();
    this.bindEvent();
  }

  get geoData(){
    return this.geoData_;
  }

  initDom() {
    this.registrationCanvas.className = 'registration-canvas';
    const dom = (document.getElementById('neuroglancer-container') as HTMLElement);
    dom.appendChild(this.registrationCanvas);
    this.updateToolBtnsDisableStatus(false);
    this.updateView();
  }

  setGeoData(data:any){
    this.geoData_ = data;
    this.updateView()
  }

  updateToolBtnsDisableStatus(flag: boolean = false) {//禁用，解禁其他控制按钮
    console.log(flag)
  }
  bindEvent() {
    let {navigationState} = this;
    navigationState = this.viewer.navigationState;
    const updateViewFunction = this.registerCancellable(animationFrameDebounce(() => this.updateView()));
    this.registerDisposer(navigationState.position.changed.add(updateViewFunction));
    this.registerDisposer(navigationState.zoomFactor.changed.add(updateViewFunction));
    this.registerDisposer(navigationState.pose.orientation.changed.add(updateViewFunction));
    // this.registerDisposer((this.viewer.display.orderedPanels[0] as SliceViewPanel).sliceView.projectionParameters.changed.add(() => {
      // this.updateView();
    // }));
    this.registerEventListener(window, 'resize', debounce(() => {
      this.updateView();
    }, 100));
  }

  updateView() {
    let projectionParameters = (this.viewer.display.orderedPanels[0] as SliceViewPanel)?.sliceView.projectionParameters.value;
    if (projectionParameters?.width !== this.registrationCanvas.width || this.registrationCanvas.height !== projectionParameters?.height) {
      this.registrationCanvas.width = projectionParameters?.width;
      this.registrationCanvas.height = projectionParameters?.height;
    }
    if (this.ctx && projectionParameters?.viewProjectionMat) {
      const ctx = this.ctx;
      ctx.imageSmoothingEnabled = false;
      ctx.clearRect(0, 0, this.registrationCanvas.width, this.registrationCanvas.height);
      if(this.is_fill === 'None')return;
      ctx.lineWidth = geoLineWidth;
      ctx.beginPath();
      if(this.is_fill === 'Outlined' || this.is_fill === 'Both'){
        this.is_fill === 'Both' ? ctx.strokeStyle = 'rgba(255,255,255,1.0)' : ctx.strokeStyle = 'rgba(255,255,255,0.7)';
      }
      // console.log(this.geoData)
      this.geoData?.geometries.forEach((item: any) => {
        const geo = item.coordinates[0];
        console.log(...projectToScreenCoord(vec2.fromValues(geo[0][0], geo[0][1]), projectionParameters), projectionParameters.viewProjectionMat)
        ctx.moveTo(...projectToScreenCoord(vec2.fromValues(geo[0][0], geo[0][1]), projectionParameters));
        for (let i = 1, len = geo.length; i < len; i++) {
          ctx.lineTo(...projectToScreenCoord(vec2.fromValues(geo[i][0], geo[i][1]), projectionParameters));
        }
        ctx.closePath();
        ctx.stroke();
        if(this.is_fill === 'Filled' || this.is_fill === 'Both'){
          ctx.fillStyle = 'rgba(255,255,255,0.5)';
          ctx.fill();
        }
      })
    }
  }

  dispose() {
    console.log('dispose')
    super.dispose();
    document.getElementsByClassName('measure_btn')[0]?.setAttribute('data-checked', 'false');
    this.registrationCanvas.remove();
  }
}
